export default "__VITE_ASSET__34d98d86__"